import { useRef, useState } from "react";
import { Upload } from "lucide-react";
import { toast } from "react-toastify";
import { uploadFile } from "../../utils/driveClient";

export default function UploadDropzone({ folderId, onUploaded, disabled }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [dragOver, setDragOver] = useState(false);

  const handleFiles = async (files) => {
    if (!files?.length) return;
    setBusy(true);
    try {
      for (const f of files) {
        try {
          const result = await uploadFile(folderId, f);
          toast.success(`Uploaded ${result.name}`);
          onUploaded && onUploaded(result);
        } catch (e) {
          toast.error(`Failed to upload ${f.name}: ${e.message}`);
        }
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      onDragOver={e => { e.preventDefault(); setDragOver(true); }}
      onDragLeave={() => setDragOver(false)}
      onDrop={e => {
        e.preventDefault();
        setDragOver(false);
        if (!disabled) handleFiles(Array.from(e.dataTransfer.files));
      }}
      className={`border-2 border-dashed rounded p-4 text-center text-sm
        ${dragOver ? "border-blue-500 bg-blue-50" : "border-gray-300"}
        ${disabled ? "opacity-50" : ""}`}
    >
      <input
        ref={inputRef}
        type="file"
        multiple
        hidden
        onChange={(e) => handleFiles(Array.from(e.target.files))}
        disabled={disabled || busy}
      />
      <Upload className="w-5 h-5 inline mr-2 -mt-0.5" />
      {busy
        ? "Uploading…"
        : <>Drag files here, or <button className="text-blue-600 underline" onClick={() => inputRef.current?.click()} disabled={disabled}>browse</button></>}
    </div>
  );
}
